
import SettingsIcon from '@mui/icons-material/Settings';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import AddTaskIcon from '@mui/icons-material/AddTask';
import FactoryIcon from '@mui/icons-material/Factory';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import FormatShapesIcon from '@mui/icons-material/FormatShapes';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CollectionsIcon from '@mui/icons-material/Collections';


const CollaborationMenu = {
  id: '101',
  title: 'Collaboration',
  type: 'group',
  role: 'PHARMA_OMS_ADMIN,PHARMA_OMS_PACKAGING, PHARMA_OMS_PROD,PHARMA_OMS_PROD-B,PHARMA_OMS_QA,PHARMA_OMS_QC,PHARMA_OMS_MD, PHARMA_OMS_STORE,PHARMA_OMS_DESIGNER, PHARMA_OMS_SALES, PHARMA_OMS_QA, PHARMA_OMS_RM, PHARMA_OMS_PM, PHARMA_OMS_MFG, PHARMA_OMS_ACCOUNTS',
  children: [
    // {
    //   id: 'orderdelivery',
    //   title: 'Order Delivery',
    //   type: 'item',
    //   url: '/',
    //   bottomMenu: 'ORDER_DELIVERY',
    //   icon: AddRoadIcon
    // },
    {
      id: 'orderapproval',
      title: 'Order Approval',
      type: 'item',
      url: '/',
      bottomMenu: 'ORDER_APPROVAL',
      icon: AddTaskIcon
    },
    {
      id: 'collaborationboard',
      title: 'Order Fullfillment',
      type: 'item',
      url: '/',
      bottomMenu: 'COLLABORATION_BOARD',
      icon: FactoryIcon
    },


    {
      id: 'tasklist',
      title: 'My Task(s)',
      type: 'item',
      url: '/',
      bottomMenu: 'MYTASKS',
      icon: FormatListNumberedIcon
    },
    {
      id: 'productstage',
      title: 'Order Progress',
      type: 'item',
      url: '/',
      bottomMenu: 'PRODUCT_STAGE_PROGRESS',
      icon: AddRoadIcon
    },
    {
      id: 'taskprogress',
      title: 'TASK Progress',
      type: 'item',
      url: '/',
      bottomMenu: 'TASK_PROGRESS',
      icon: TaskAltIcon
    },
    {
      id: 'pmorder',
      title: 'PM Order',
      type: 'item',
      url: '/',
      bottomMenu: 'PM_ORDER',
      icon: FormatShapesIcon
    },
    {
      id: 'approveddesign',
      title: 'Approved Design',
      type: 'item',
      url: '/',
      bottomMenu: 'APPROVED_DESIGN',
      icon: CollectionsIcon
    },

  ]
};

export default CollaborationMenu;